<template>
    <div class="photos-main" id="photos-section-share">
<!--        <div class="title-wrapper">-->
<!--            <div class="col-title">-->
<!--                <span class="title">Muestra las fotos que tan orgulloso te hacen sentir</span>-->
<!--            </div>-->
<!--            <div v-if="!showForm" class="col-title">-->
<!--                <span class="share-btn" @click="showForm = true">Comparte tus fotos</span>-->
<!--            </div>-->
<!--        </div>-->
        <b-modal scrollable centered size="xl" v-model="showForm" hide-footer title="Compartir fotos" static>
            <p class="mb-2">
                Las fotografías serán revisadas por el equipo de Babyplant antes de ser publicadas.
            </p>
            <b-form-file v-model="imageForm" accept="image/jpeg, image/png, image/gif, image/svg, image/bmp" placeholder="Elige una imagen o arrástrala aquí..."
                         browse-text="Buscar"></b-form-file>
            <small>Al enviar el formulario, aceptas los términos y condiciones y la política de privacidad.</small>
<!--            <span class="cart-checkbox-group" :class="{checked: mostrarNombreForm}" @click="mostrarNombreForm = !mostrarNombreForm">-->
<!--                <span class="checkbox"></span>-->
<!--                Mostrar mi nombre en la publicación-->
<!--            </span>-->
            <div>
                <div class="btn-enviar" :class="{disabled: sending}" @click="enviarImagen">
                    Enviar
                    <b-spinner v-if="sending" style="color: #006030 !important;width:1rem;height:1rem" label="Spinning"></b-spinner>
                </div>
            </div>
        </b-modal>
        <div v-if="sent" class="sent-message">
            <div class="close-icon-wrapper" @click="sent = false">
                <i class="fas fa-times"></i>
            </div>
            <h3>Recibida, ¡Gracias!</h3>
            <h5>Pronto se mostrará tu foto</h5>
        </div>
        <div v-if="loadingImages" class="load-spinner-wrapper">
            <load-spiner class="load-spinner-fotos"></load-spiner>
        </div>
        <div class="grid">
            <template v-for="(image, index) in imagesShowing">
                <div v-if="!image.publicar" class="cell-photo" :key="image.id" :class="{'giant': shouldBeGiant(index)}">
                    <img :src="image.src" class="photo" :alt="'Imagen de '+image.autor">
                    <div class="photo-hover">
                        <div class="photo-hover-provincia">
                            {{ image.provincia_nombre }}
                        </div>
                        <div class="photo-hover-date">
                            {{ image.fecha }}
                        </div>
                    </div>
                </div>
                <div v-else class="cell-photo publicar">
                    <div class="photo-hover">
                        <div class="photo-hover-title">
                            ¿Quieres ver tu foto aquí?
                        </div>
                        <div class="photo-hover-btn" @click="openForm">
                            Publícala
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <b-button v-if="canShowMore" @click="showMore" class="show-more-btn">Ver más</b-button>
    </div>
</template>

<script>

export default {
    name: "CompartirFotosComponent",
    props: {
        logged: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 10,
                /*centeredSlides: true,*/
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                touchStartPreventDefault: false,
            },
            images: [],
            loadingImages: false,
            sending: false,
            sent: false,
            showForm: false,
            imageForm: null,
            mostrarNombreForm: false,
            gridColumns: 6,
            showDoubleRows: 1, // Increments with show more
            publicarIndex: 2
        }
    },
    computed: {
        imagesByDoubleRow() {
            return this.gridColumns * 2 - 3;
        },
        maxDoubleRows() {
            return Math.floor((this.images.length + 1) / this.imagesByDoubleRow);
        },
        maxDoubleRowsIncompleted(){
            let max = this.maxDoubleRows;
            if ((this.images.length + 1) % this.imagesByDoubleRow > 0) {
                max++;
            }
            return max;
        },
        giants() {
            let imagesCount = this.imagesShowing.length;
            let imagesByDoubleRow = this.imagesByDoubleRow;
            let doubleRows = Math.floor(imagesCount / imagesByDoubleRow);
            let giants = [];
            let columnsSelected = [4, 3, 5, 2, 1]; // Random
            for (let doubleRow = 1; doubleRow <= doubleRows; doubleRow++) {
                let columnSelectedIndex = (doubleRow - 1) % columnsSelected.length;
                let column = columnsSelected[columnSelectedIndex];
                let cell = (doubleRow - 1) * imagesByDoubleRow + column;
                giants.push(cell);
            }
            return giants;
        },
        imagesShowing() {
            let maxImages = this.showDoubleRows * this.imagesByDoubleRow -1;
            let publicar = {
                publicar: true
            };
            let imagesShowing = this.images.filter((item, index) => index < maxImages);
            imagesShowing.splice(2, 0, publicar);
            return imagesShowing;
        },
        canShowMore() {
            return this.showDoubleRows < this.maxDoubleRowsIncompleted;
        }
    },
    methods: {
        getFotos() {
            this.loadingImages = true;
            axios.get(this.route('fotos-compartidas.get')).then(response => {
                this.images = response.data;
            }).finally(() => {
                this.loadingImages = false;
            });
        },
        enviarImagen() {
            if (this.sending) {
                return;
            }
            if (!this.imageForm) {
                Vue.toasted.show('Debes seleccionar una imagen primero', {
                    type: "error",
                    duration: 3000
                });
                return;
            }
            this.sending = true;
            let formData = new FormData();
            formData.append('image', this.imageForm);
            formData.append('mostrar_nombre', this.mostrarNombreForm ? 1 : 0);
            axios.post(this.route('fotos-compartidas.store'), formData).then(response => {
                this.sent = true;
                this.imageForm = null;
                this.mostrarNombreForm = false;
                this.showForm = false;
                this.$el.scrollIntoView({
                    behavior: 'auto',
                    block: 'center',
                    inline: 'center'
                });
            }).catch(error => {
                Vue.toasted.show('Ha ocurrido un error al intentar enviar la foto', {
                    type: "error",
                    duration: 3000
                });
            }).finally(() => {
                this.sending = false;
            });
        },
        shouldBeGiant(index) {
            return this.giants.findIndex(g => g === index + 1) > -1;
        },
        showMore() {
            this.showDoubleRows++;
        },
        openForm() {
            if (this.logged) {
                this.showForm = true;
            } else {
                window.location = this.route('fotos-compartidas.auth');
            }
        }
    },
    created() {
        this.getFotos();
    },
    mounted() {
        if (window.location.hash === '#photos-section-share') {
            this.$el.scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center'
            });
            this.openForm();
        }
    }
}
</script>

<style scoped>

.photos-main {
    max-width: 1600px;
    margin: auto;
}

.title-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
}

.col-title {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-bottom: 0.5rem;
}

.title {
    font-weight: bold;
    font-size: 1.575rem;
    line-height: 1.3;
}

.share-btn {
    background-color: transparent;
    color: #058b84;
    cursor: pointer;
    border: 2px solid #058b84;
    border-radius: 0;
    font-weight: bold;
    padding: 0 10px;
    font-size: 19px;
    user-select: none;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
}

.grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0.3rem;
    margin-bottom: 1.2rem;
    margin-top: 1.2rem;
}

.grid > .cell-photo {
    background: #078c85;
    position: relative;
}

.grid > .cell-photo::before {
    content: "";
    padding-bottom: 100%;
    display: block;
}

.grid > .cell-photo > .photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    z-index: 1;
}

.grid > .cell-photo:hover > .photo {
    z-index: 0;
}

.photo-hover {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(5, 139, 132, 0.8);
    color: #fff;
}

.cell-photo.publicar > .photo-hover {
    padding: 0.5rem;
}

.photo-hover-provincia {
    font-weight: bold;
}

.photo-hover-title {
    font-size: 1.5rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 1rem;
}

.photo-hover-btn {
    font-size: 1.2rem;
    border: 2px solid;
    padding: 0.3rem 3.7rem;
    cursor: pointer;
    user-select: none;
}

.show-more-btn {
    background-color: #058b84;
    color: #fff;
    font-weight: bold;
    padding: 0.375rem 4rem;
    font-size: 1rem;
    display: block;
    margin: 0 auto 1.2rem auto;
    border: 0;
}

.load-spinner-wrapper {
    height: 300px;
    display: flex;
    align-items: center;
}

.cart-checkbox-group {
    cursor: pointer;
    display: block;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    position: relative;
}

.cart-checkbox-group span.checkbox {
    padding: 0 8.5px;
    border: 1px solid #333;
    position: relative;
    margin-right: 0.5rem;
}

.cart-checkbox-group:hover span.checkbox:after,
.cart-checkbox-group.checked span.checkbox:after {
    border-color: #c7cf34;
}

.btn-enviar {
    cursor: pointer;
    color: #058b84;
    border: 1px solid #058b84;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    font-size: 0.9rem;
    line-height: 1.6;
    vertical-align: middle;
    text-align: center;
    user-select: none;
    display: inline-block;
    margin-top: 1rem;
}

.btn-enviar.disabled {
    background-color: #ffffff;
    color: #a2a2a2;
    border-color: #a2a2a2;
    cursor: no-drop;
}

.btn-enviar:not(.disabled):hover {
    color: #fff;
    background-color: #058b84;
    border-color: #058b84;
}

.sent-message {
    background-color: #058b84;
    color: #ffffff;
    padding: 1rem 0.75rem;
    margin-top: 0.75rem;
    position: relative;
}

.close-icon-wrapper {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    font-size: 1.5rem;
    line-height: 1;
    padding: 0.25rem;
    cursor: pointer;
}

@media (min-width: 992px) {
    .grid > .cell-photo.giant {
        grid-column: span 2;
        grid-row: span 2;
    }

    .grid {
        grid-template-columns: repeat(6, 1fr);
    }
}

@media (min-width: 992px) {
    .photo-hover-title {
        font-size: 1.2rem;
    }
    .photo-hover-btn {
        padding: 0.1rem 1.7rem;
    }
}

@media (min-width: 1200px) {
    .photo-hover-title {
        font-size: 1.5rem;
    }
    .photo-hover-btn {
        padding: 0.2rem 2.7rem;
    }
}

@media (min-width: 1500px) {
    .photo-hover-btn {
        padding: 0.3rem 3.7rem;
    }
}

</style>

<style>
.cart-checkbox-group:hover span.checkbox:after,
.cart-checkbox-group.checked span.checkbox:after {
    content: "";
    border-left: 5px solid;
    border-bottom: 5px solid;
    position: absolute;
    padding: 4px 10px;
    transform: rotate(-50deg);
    left: 2px;
    bottom: 8px;
}
</style>
